<div id="viewSourcesModalDialog" class="modal fade" role="dialog" aria-labelledby="viewSourcesModalDialog"
  aria-hidden="true">
  <div class="e-modal-dialog e-modal-dialog-centered" role="document" cdkDrag cdkDragBoundary=".modal">
    <div [className]="isMinimizeState ? 'e-modal-content' : 'e-modal-content e-modal-content-maximize'">
      <div class="e-modal-header" cdkDragHandle>
        <h1 class="e-modal-title" matTooltip="detailedEditingOptions.title" matTooltipClass="e-tooltip e-tab-tooltip">
          {{ dialogTitle }}
        </h1>
        <button type="button" class="e-maximize" (click)="this.restoreState()">
          <span class="fal fa-square" title="maximize" *ngIf="isMinimizeState"></span>
          <span class="fal fa-window-restore" title="minimize" *ngIf="!isMinimizeState"></span>
        </button>
        <button type="button" class="e-close" data-dismiss="modal" aria-label="Close" (click)="onClose()">
          <span class="fal fa-times" title="Close"></span>
        </button>
      </div>
      <div class="e-modal-body" cdkScrollable>
        <form class="sources-dynamic-form" [formGroup]="form">
          <div class="e-filter-contents">
            <div class="e-claims-form-container">

              <div class="form-col">
                <label class="form-label">Client*</label>
                <input class="form-input" type="text" formControlName="client" maxlength="259"
                  [title]="getClientTooltip()" [placeholder]="isViewMode ? '' : placeholders.CLIENT_NAME" />
                <div class="form-error" *ngIf="form.get('client')?.invalid && form.get('client')?.dirty">
                  <span *ngIf="form.get('client')?.errors?.['required']">Client is required</span>
                  <span *ngIf="form.get('client')?.errors?.['maxlength']">Max 259 characters allowed</span>
                </div>
              </div>

              <div class="form-col">
                <label class="form-label">CRM Account ID*</label>
                <input class="form-input" type="text" formControlName="sfAccountId" maxlength="259" required
                  [title]="getSfAccountTooltip()" [placeholder]="isViewMode ? '' : placeholders.CRM_ACCOUNT"
                  (blur)="getCrmCompanyMapping()" />
                <div class="form-error" *ngIf="form.get('sfAccountId')?.invalid && form.get('sfAccountId')?.dirty">
                  <span *ngIf="form.get('sfAccountId')?.errors?.['required']">CRM Account ID is required</span>
                  <span *ngIf="form.get('sfAccountId')?.errors?.['maxlength']">Max 259 characters allowed</span>
                  <span *ngIf="form.get('sfAccountId')?.errors?.['pattern']">Invalid Account ID</span>
                </div>
                <div class="crm-mapping-message" *ngIf="crmAccountMappingMessage && !form.get('sfAccountId')?.errors">
                  <span>{{ crmAccountMappingMessage }}</span>
                </div>
              </div>

              <div class="form-col">
                <emma-generic-search [items]="opportunityOwnerSearchOptions"
                  [placeholder]="isViewMode ? '' : placeholders.ENTER_FOR_RESULT" [label]="'Opportunity Owner'"
                  [required]="false" [showCode]="false" [clearable]="true" [minTermLength]="3"
                  [showNoResultsMessage]="false" [bindLabel]="'name'" [bindValue]="'code'"
                  [tooltip]="getOpportunityOwnerTooltip()" (searchEvent)="onOpportunityOwnerSearch($event)"
                  (selectEvent)="onOpportunityOwnerSelect($event)" (enterEvent)="onOpportunityOwnerEnter()"
                  formControlName="opportunityOwnerEmail">
                </emma-generic-search>
              </div>

              <div class="form-col">
                <emma-generic-search #officeCodeDisplay [items]="officeCodeSearchOptions"
                  [placeholder]="isViewMode ? '' : placeholders.SELECT_OFFICE"
                  [searchPlaceholder]="placeholders.SEARCH_OFFICE" [label]="'Office*'" [required]="true"
                  [showCode]="false" [clearable]="true" [minTermLength]="0" [bindValue]="'name'"
                  [showAsDropdown]="!isViewMode" [showNoResultsMessage]="false" [tooltip]="getIOfficeTooltip()"
                  (searchEvent)="onIOfficeSearch($event)" (selectEvent)="onIOfficeSelect($event)"
                  (clickEvent)="onIOfficeClick()" formControlName="officeCodeDisplay">
                </emma-generic-search>
                <div class="form-error"
                  *ngIf="form.get('officeCodeDisplay')?.invalid && form.get('officeCodeDisplay')?.dirty">
                  <span *ngIf="form.get('officeCodeDisplay')?.errors?.['required']">Office is required</span>
                </div>
              </div>

              <div class="form-col">
                <emma-generic-search #claimRenewalId label="Claim Renewal"
                  [placeholder]="isViewMode ? '' : placeholders.SELECT_CLAIM" [items]="claimRenewalSearchOptions"
                  [required]="false" [showAsDropdown]="!isViewMode" [isLoading]="isLoadingClaimRenewal"
                  [bindLabel]="'name'" [bindValue]="'id'" [tooltip]="getClaimRenewalTooltip()"
                  formControlName="claimRenewalId" (searchEvent)="onClaimRenewalSearch($event)"
                  (enterEvent)="onClaimRenewalEnter()" (clickEvent)="onClaimRenewalClick()"
                  (selectEvent)="onClaimRenewalSelect($event)">
                </emma-generic-search>
              </div>

              <div class="form-col">
                <label>Expiry Date*</label>
                <div class="e-date-picker">
                  <mat-form-field appearance="fill">
                    <input #expiryDateInput matInput [matDatepicker]="expiryDatePicker" formControlName="expiryDate"
                      required [placeholder]="isViewMode ? '' : placeholders.DATE_FORMAT" aria-haspopup="dialog"
                      [title]="getExpiryDateTooltip()" />
                    <mat-datepicker-toggle matIconSuffix [for]="expiryDatePicker"></mat-datepicker-toggle>
                    <mat-datepicker #expiryDatePicker></mat-datepicker>
                  </mat-form-field>
                </div>
                <div class="form-error" *ngIf="form.get('expiryDate')?.invalid && form.get('expiryDate')?.dirty">
                  <span
                    *ngIf="form.get('expiryDate')?.errors?.['matDatepickerParse'] || (form.get('expiryDate')?.errors?.['required'] && expiryDateInput.value)">Please
                    enter a valid date</span>
                  <span *ngIf="form.get('expiryDate')?.errors?.['required'] && !expiryDateInput.value">Expiry Date is
                    required</span>
                </div>
              </div>

              <div class="form-col">
                <emma-generic-search [items]="researchUserSearchOptions"
                  [placeholder]="isViewMode ? '' : placeholders.ENTER_FOR_RESULT" [label]="'Research User'"
                  [required]="false" [showCode]="false" [clearable]="true" [minTermLength]="3"
                  [showNoResultsMessage]="false" [bindLabel]="'name'" [bindValue]="'id'"
                  [tooltip]="getResearchUserTooltip()" (searchEvent)="onResearchUserSearch($event)"
                  (selectEvent)="onResearchUserSelect($event)" (enterEvent)="onResearchUserEnter()"
                  formControlName="mainResearchUserId">
                </emma-generic-search>
              </div>

              <div class="form-col">
                <label class="form-label">Claim Wording*</label>
                <input class="form-input" type="text" formControlName="claimWording" maxlength="500" required
                  [title]="getClaimWordingTooltip()" [placeholder]="isViewMode ? '' : placeholders.CLAIM_WORDING" />
                <div class="form-error" *ngIf="form.get('claimWording')?.invalid && form.get('claimWording')?.dirty">
                  <span *ngIf="form.get('claimWording')?.errors?.['required']">Claim Wording is required</span>
                  <span *ngIf="form.get('claimWording')?.errors?.['maxlength']">Max 500 characters allowed</span>
                </div>
              </div>

              <div class="form-col">
                <label class="form-label">Claim Footnote*</label>
                <input class="form-input" type="text" formControlName="claimFootnote" maxlength="500" required
                  [title]="getClaimFootnoteTooltip()" [placeholder]="isViewMode ? '' : placeholders.CLAIM_FOOTNOTE" />
                <div class="form-error" *ngIf="form.get('claimFootnote')?.invalid && form.get('claimFootnote')?.dirty">
                  <span *ngIf="form.get('claimFootnote')?.errors?.['required']">Claim Footnote is required</span>
                  <span *ngIf="form.get('claimFootnote')?.errors?.['maxlength']">Max 500 characters allowed</span>
                </div>
              </div>

              <div class="form-col">
                <label>Counter Sign Date*</label>
                <div class="e-date-picker">
                  <mat-form-field appearance="fill">
                    <input #counterSignDateInput matInput [matDatepicker]="counterSignDatePicker"
                      formControlName="counterSignDate" required
                      [placeholder]="isViewMode ? '' : placeholders.DATE_FORMAT" aria-haspopup="dialog"
                      [title]="getCounterSignDateTooltip()" />
                    <mat-datepicker-toggle matIconSuffix [for]="counterSignDatePicker"></mat-datepicker-toggle>
                    <mat-datepicker #counterSignDatePicker></mat-datepicker>
                  </mat-form-field>
                </div>
                <div class="form-error"
                  *ngIf="form.get('counterSignDate')?.invalid && form.get('counterSignDate')?.dirty">
                  <span
                    *ngIf="form.get('counterSignDate')?.errors?.['matDatepickerParse'] || (form.get('counterSignDate')?.errors?.['required'] && counterSignDateInput.value)">Please
                    enter a valid date</span>
                  <span *ngIf="form.get('counterSignDate')?.errors?.['required'] && !counterSignDateInput.value">Counter
                    Sign Date is required</span>
                </div>
              </div>

              <div class="form-col">
                <label class="form-label">CRM Link</label>
                <input class="form-input" type="text" formControlName="crmLink" maxlength="250"
                  [title]="getCrmLinkTooltip()" [placeholder]="isViewMode ? '' : placeholders.CRM_LINK" />
                <div class="form-error" *ngIf="form.get('crmLink')?.invalid && form.get('crmLink')?.dirty">
                  <span *ngIf="form.get('crmLink')?.errors?.['maxlength']">Max 250 characters allowed</span>
                  <span *ngIf="form.get('crmLink')?.errors?.['pattern']">Must be a valid URL (http/https)</span>
                </div>
              </div>

              <div class="form-col language-dropdown-wrapper">
                <emma-generic-search #languageTranslation label="Language Translation"
                  [placeholder]="isViewMode ? '' : placeholders.SELECT_LANGUAGE"
                  [searchPlaceholder]="placeholders.SEARCH_LANGUAGE" [items]="languageSearchOptions" [required]="false"
                  [showAsDropdown]="!isViewMode" [isLoading]="isLoadingLanguages" [bindLabel]="'name'"
                  [bindValue]="'id'" [minTermLength]="0" [showNoResultsMessage]="false" [suppressGuidDisplay]="true"
                  [tooltip]="getLanguageTranslationTooltip()" formControlName="languageTranslation"
                  (searchEvent)="onLanguageSearch($event)" (selectEvent)="onLanguageSelect($event)"
                  (clickEvent)="onLanguageClick()">
                </emma-generic-search>
              </div>

            </div>
          </div>
        </form>
      </div>
      <div class="e-modal-footer">
        <div class="e-buttons-footer close-btn">
          <button type="button" class="e-dialog-button e-cancel-dialog-button e-button-secondary" data-dismiss="modal"
            (click)="onClose()">
            Cancel
          </button>
        </div>
        @if (!isViewMode) {
        <div class="e-buttons-footer continue-btn">
          <button type="button" class="e-dialog-button e-accept-dialog-button"
            [disabled]="!isFormValid || !hasFormChanged" (click)="onSubmit()">
            Save
          </button>
        </div>
        }
      </div>
    </div>
  </div>
</div>